module.exports = __webpack_public_path__ + "media/katarina_opening_scene.8f206d80.mp4";